import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  routes: [],
  activeRoutes: [],
};

const routesSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    setRoutes: (state, action) => {
      state.routes = action.payload;
      localStorage.setItem("routes", JSON.stringify(action.payload));
    },
    setActiveRoutes: (state, action) => {
      state.activeRoutes = action.payload;
      localStorage.setItem("active_routes", JSON.stringify(action.payload));
    },
  },
});

export const { setRoutes, setActiveRoutes } = routesSlice.actions;
export const selectRoutes = (state) => {
  const localItem = JSON.parse(localStorage.getItem("routes"));
  if (!localItem) {
    return state.nav.routes;
  } else {
    return localItem;
  }
}
export const selectActiveRoutes = (state) => {
  const localItem = JSON.parse(localStorage.getItem("active_routes"));
  if (!localItem) {
    return state.nav.activeRoutes;
  } else {
    return localItem;
  }
};
export default routesSlice.reducer;
